import React from 'react'
// import ComingSoon from './ComingSoon';
import GlimpsesList from '../../components/Releases/Glimpses';

export default function Podcasts(props) {

    const setTitle = props.setTitle;
    const setProgress = props.setProgress;

    React.useEffect(() => {
        setTitle("Glimpses - Academic Outreach and New Initiatives | IIT Delhi")
        setProgress(100);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <GlimpsesList />
    )
}
